import { render, staticRenderFns } from "./SysTypeList.vue?vue&type=template&id=fa4a47fa&scoped=true&"
import script from "./SysTypeList.vue?vue&type=script&lang=js&"
export * from "./SysTypeList.vue?vue&type=script&lang=js&"
import style0 from "./SysTypeList.vue?vue&type=style&index=0&id=fa4a47fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4a47fa",
  null
  
)

export default component.exports